// Espelha o shape servido por GET /:recurso/:id/transicoes e
// GET /:recurso/:id/auditoria — fonte única é a tabela do core (SPEC-UX §3.1).
export type StatusDerivado = 'Verde' | 'Amarelo' | 'Vermelho';

// Shape exato devolvido por GET /:recurso/:id/transicoes
// (apps/compasso/src/api/transicoes-disponiveis.ts). "label" não vem da
// API — o backend fala nome de evento técnico, não texto de usuário (regra
// §C3: "core assume entrada válida... nunca texto de usuário no core");
// o rótulo em verbo (§3.2 "ação em verbo") é derivado no cliente por
// labelEvento().
export interface TransicaoDisponivel {
  evento: string;
  para: string;
  exigeJustificativa: boolean;
  disponivel: boolean;
}

const LABEL_EVENTO: Record<string, string> = {
  submeter: 'Submeter',
  iniciarTriagem: 'Iniciar triagem',
  aprovarMerito: 'Aprovar mérito',
  rejeitar: 'Rejeitar',
  autorizar: 'Autorizar execução',
  colocarEmEspera: 'Colocar em espera',
  reavaliar: 'Reavaliar',
  instanciar: 'Instanciar projeto',
  publicar: 'Publicar',
  descontinuar: 'Descontinuar',
  aprovarBaseline: 'Aprovar baseline',
  iniciarExecucao: 'Iniciar execução',
  suspender: 'Suspender',
  retomar: 'Retomar',
  cancelar: 'Cancelar',
  concluir: 'Concluir',
  iniciar: 'Iniciar',
  submeterAoGate: 'Submeter ao gate',
  aprovarGate: 'Aprovar gate',
  reprovarGate: 'Reprovar gate',
  bloquear: 'Bloquear',
  desbloquear: 'Desbloquear',
  tratar: 'Tratar',
  escalar: 'Escalar',
  mitigar: 'Mitigar',
  fechar: 'Fechar',
  ativar: 'Ativar',
  sinalizarRisco: 'Sinalizar risco',
  normalizar: 'Normalizar',
  reativar: 'Reativar',
  iniciarRealizacao: 'Iniciar realização de benefício',
  iniciarMedicao: 'Iniciar medição',
  realizar: 'Marcar como realizado',
  aceitarNaoRealizado: 'Aceitar não realizado',
  aprovar: 'Aprovar',
};

export function labelEvento(evento: string): string {
  return LABEL_EVENTO[evento] ?? evento;
}

export interface EventoAuditoriaApi {
  id: string;
  entidade_tipo: string;
  entidade_id: string;
  estado_de: string | null;
  estado_para: string;
  evento: string;
  ator: string;
  justificativa: string | null;
  ocorrido_em: string;
}

export interface ChipStatus {
  status: StatusDerivado;
  formula: string;
  fonte: string;
  valor: number;
  meta: number;
  fresco: boolean;
  calculadoEm: string;
}
